import { Button, Checkbox, CheckboxGroup, Stack, Switch, Text } from '@chakra-ui/react';
import { RequestStatus } from '@pelicargo/types';
import { requestStatusOptions } from '@pelicargo/utils';
import { useCallback } from 'react';
import { HiChevronLeft } from 'react-icons/hi';

import { RequestFilters } from '../../hooks/useRequestFilters';

type Props = {
  filters: RequestFilters;
  handleCheckboxFilterChange: (key: string) => (nextValue: string[]) => void;
  resetView: () => void;
};

export const RequestStatusFilter = ({ filters, handleCheckboxFilterChange, resetView }: Props) => {
  const statuses = Object.values(RequestStatus);

  const handleToggleAll = useCallback(() => {
    if (filters.status?.length === statuses?.length) {
      handleCheckboxFilterChange('status')([]);
    } else {
      handleCheckboxFilterChange('status')(statuses);
    }
  }, [filters.status, handleCheckboxFilterChange, statuses]);

  return (
    <Stack spacing="2" pt="2">
      <Stack direction="row" align="center" spacing="2">
        <Button variant="ghost" textStyle="label" size="xs" leftIcon={<HiChevronLeft />} onClick={resetView}>
          Request Status
        </Button>
      </Stack>
      <Stack direction="row" align="center" justify="space-between" w="full">
        <Text>Select all</Text>
        <Switch size="sm" isChecked={filters.status?.length === statuses?.length} onChange={handleToggleAll} />
      </Stack>
      <Stack>
        <CheckboxGroup value={filters.status} onChange={handleCheckboxFilterChange('status')}>
          {requestStatusOptions?.map((node) => (
            <Checkbox key={node.value} value={node.value}>
              {node.label}
            </Checkbox>
          ))}
        </CheckboxGroup>
      </Stack>
    </Stack>
  );
};
